import React, { Component } from 'react'
import {connect} from 'react-redux'
import CONFIG from 'base/constants/config';

class AdsContainer extends Component {
  componentDidUpdate(prevProps, prevState) {
    if(this.props.SystemInfo !== prevProps.SystemInfo) {
      this.forceUpdate();
    }
  }
  render() {
    let {SystemInfo} = this.props;
    let listAds = SystemInfo && SystemInfo.additionalModulesInfo && SystemInfo.additionalModulesInfo.data && SystemInfo.additionalModulesInfo.data.map(item => {
      return(
        <div className='item-ads'>
          <div className='item-img' style={{backgroundImage: `url(${CONFIG.API_URL}/containers/fairs/download/${item.image})`}}>
            {item.link && (<a href={item.link} target='_blank' className='item-link'></a>)}
          </div>
        </div>
      )
    })
    return (
      <div className='center'>
        <div className='list-ads'>
          {listAds}
        </div>
      </div>
    );
  }
}

const bindStateToProps = (state) => {
  return {
    SystemInfo: state.System.data || {}
  };
};

export default connect(bindStateToProps)(AdsContainer);


// WEBPACK FOOTER //
// ./components/home/sub-view/AdsContainer.jsx